/**
 * The MVP 2 landing copy, passed to `LandingScreen` over V1's defaults.
 *
 * Its own module so the flow and its test read the same values: the test held
 * a copy, and the copy went stale when this changed.
 */
export const V2_LANDING = {
  headline: 'Plan for the life you want today and in the years ahead.',
  body: [
    'Your financial plan is about more than retirement. It’s about preparing for the years ahead, including how health, home, family responsibilities, support needs and finances may evolve over time.',
    // Names the supporter path up front, which is what the assessment
    // now does — the questions change voice on the D1 answer.
    'Whether you’re planning for yourself or helping support someone you care about, this short assessment will help you and your advisor understand what’s already in place, what may need attention and what may be worth planning for next.',
  ],
  duration: '~15 minutes',
  // Ten discovery questions and then the twenty-five readiness ones.
  // The feedback asked for 30, which was written against V1; product
  // confirmed 35, the base path. Conditionals can take a given client
  // higher — a supporter also answers D1A, hands-on support reveals
  // D4A and D4B, and an escalation gate adds four checks, up to 42 —
  // and product chose the base number over a range.
  questionCount: '35 questions',
  privacy: 'Secure',
};
